import { render, staticRenderFns } from "./CatalogFilters.vue?vue&type=template&id=1bd87f05&"
import script from "./CatalogFilters.vue?vue&type=script&lang=js&"
export * from "./CatalogFilters.vue?vue&type=script&lang=js&"
import style0 from "./CatalogFilters.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports